export const PATIENT_INTAKE_KEYS = {
  all: ['patient-intake'] as const,
  list: (userid: string | number, opts?: Record<string, unknown>) => [...PATIENT_INTAKE_KEYS.all, String(userid), opts ?? {}] as const,
} as const;
